"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageCollectionData = exports.attachCollectionTelemetry = void 0;
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var UseAnalyticsAccountSettings_1 = require("../UseAnalyticsAccountSettings");
var Types_2 = require("Reports/Types");
function attachCollectionTelemetry(crudOperations, telemetry, accountId) {
    var _this = this;
    var data = crudOperations.data, deleter = crudOperations.deleter, creator = crudOperations.creator, updater = crudOperations.updater;
    var deleterWithTelemetry = function (id) { return __awaiter(_this, void 0, Promise, function () {
        var numberCollections;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    numberCollections = data.pageCollections.length;
                    return [4, deleter(id)];
                case 1:
                    _a.sent();
                    fireCollectionsTelemetry(telemetry, {
                        change_type: "delete",
                        account_id: accountId,
                        collection_count_before: numberCollections,
                        collection_count_after: numberCollections - 1,
                    });
                    return [2];
            }
        });
    }); };
    var creatorWithTelemetry = function () { return __awaiter(_this, void 0, Promise, function () {
        var numberCollections;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, creator()];
                case 1:
                    _a.sent();
                    numberCollections = data.pageCollections.length;
                    fireCollectionsTelemetry(telemetry, {
                        change_type: "add",
                        account_id: accountId,
                        collection_count_before: numberCollections - 1,
                        collection_count_after: numberCollections,
                    });
                    return [2];
            }
        });
    }); };
    var updaterWithTelemetry = function (updateData) { return __awaiter(_this, void 0, Promise, function () {
        var updatedCollection, originalCollection, changes, changes_1, changes_1_1, change;
        var e_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    updatedCollection = data.pageCollections.find(function (_a) {
                        var _id = _a._id;
                        return _id === updateData._id;
                    });
                    originalCollection = (0, cloneDeep_1.default)(updatedCollection);
                    return [4, updater(updateData)];
                case 1:
                    _b.sent();
                    changes = findWhatChangedInCollection(originalCollection, updateData);
                    try {
                        for (changes_1 = __values(changes), changes_1_1 = changes_1.next(); !changes_1_1.done; changes_1_1 = changes_1.next()) {
                            change = changes_1_1.value;
                            telemetry.track(Types_2.ReportTelemetryEventName.CollectionChanged, __assign({ account_id: accountId }, buildUpdateTelemetryproperties(change, originalCollection, updateData)), { blockIntercom: true });
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (changes_1_1 && !changes_1_1.done && (_a = changes_1.return)) _a.call(changes_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return [2];
            }
        });
    }); };
    return { data: data, deleter: deleterWithTelemetry, creator: creatorWithTelemetry, updater: updaterWithTelemetry };
}
exports.attachCollectionTelemetry = attachCollectionTelemetry;
function usePageCollectionData() {
    var _this = this;
    var _a = (0, UseAnalyticsAccountSettings_1.useAnalyticsAccountSettings)(), data = _a.data, updatePageCollections = _a.updatePageCollections;
    var deleter = function (id) { return __awaiter(_this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, updatePageCollections(deletePageCollection(data, id))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var creator = function () { return __awaiter(_this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, updatePageCollections(createPageCollection(data))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var updater = function (updateData) { return __awaiter(_this, void 0, Promise, function () {
        var updatedSetting;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedSetting = updatePageCollection(data, updateData);
                    return [4, updatePageCollections(updatedSetting.pageCollections, updatedSetting)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    return { data: data, deleter: deleter, creator: creator, updater: updater };
}
exports.usePageCollectionData = usePageCollectionData;
function deletePageCollection(analyticsSettings, id) {
    return analyticsSettings.pageCollections.filter(function (c) { return c._id !== id; });
}
function createPageCollection(analyticsSettings) {
    return __spreadArray(__spreadArray([], __read(analyticsSettings.pageCollections), false), [Types_1.NEW_DEFAULT_PAGE_COLLECTION], false);
}
function updatePageCollection(analyticsSettings, updatedCollection) {
    var updatedCollectionIndex = analyticsSettings.pageCollections.findIndex(function (_a) {
        var _id = _a._id;
        return _id === updatedCollection._id;
    });
    var originalCollection = analyticsSettings.pageCollections[updatedCollectionIndex];
    if (updatedCollectionIndex >= 0) {
        analyticsSettings.pageCollections[updatedCollectionIndex] = __assign(__assign({}, originalCollection), updatedCollection);
    }
    else {
        throw new Error("Could not find collection with id ".concat(updatedCollection._id));
    }
    if (updatedCollection.isDefault) {
        var currentDefaultCollectionIndex = analyticsSettings.pageCollections.findIndex(function (_a) {
            var _id = _a._id, isDefault = _a.isDefault;
            return isDefault && _id != updatedCollection._id;
        });
        if (currentDefaultCollectionIndex >= 0) {
            analyticsSettings.pageCollections[currentDefaultCollectionIndex] = __assign(__assign({}, analyticsSettings.pageCollections[currentDefaultCollectionIndex]), { isDefault: false });
        }
    }
    return analyticsSettings;
}
function fireCollectionsTelemetry(telemetry, properties) {
    telemetry.track(Types_2.ReportTelemetryEventName.CollectionChanged, {
        change_type: properties.change_type,
        account_id: properties.account_id,
        collection_count_before: properties.collection_count_before,
        collection_count_after: properties.collection_count_after,
    }, { blockIntercom: true });
}
function findWhatChangedInCollection(originalCollection, updatedCollection) {
    var e_2, _a;
    var keysChanged = [];
    try {
        for (var _b = __values(Object.entries(originalCollection)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (JSON.stringify(value) !== JSON.stringify(updatedCollection[key])) {
                keysChanged.push(key);
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return keysChanged;
}
function buildUpdateTelemetryproperties(change, originalCollection, updatedCollection) {
    switch (change) {
        case "name":
            return {
                update_type: "collection_name",
                update_collection_value: updatedCollection.name,
            };
        case "isDefault":
            return {
                update_type: "collection_default",
                update_collection_value: true,
            };
        case "engagementAlgorithm":
            return {
                update_type: "engagement",
            };
        case "pageFilter":
            var filterProperties = {};
            if (JSON.stringify(originalCollection.pageFilter.templateIds) !==
                JSON.stringify(updatedCollection.pageFilter.templateIds)) {
                filterProperties = __assign(__assign({}, filterProperties), { update_filter_templates: updatedCollection.pageFilter.templateIds.join(", ") });
            }
            if (JSON.stringify(originalCollection.pageFilter.tags) !== JSON.stringify(updatedCollection.pageFilter.tags)) {
                filterProperties = __assign(__assign({}, filterProperties), { update_filter_tags: updatedCollection.pageFilter.tags.join(", ") });
            }
            if (originalCollection.pageFilter.pageWith !== updatedCollection.pageFilter.pageWith) {
                filterProperties = __assign(__assign({}, filterProperties), { update_filter_content: Types_2.includedPagesTypeTelemetryMapping[updatedCollection.pageFilter.pageWith] });
            }
            return __assign({ update_type: "filter" }, filterProperties);
    }
}
